import type { Brand, BrandCode } from "core/entities";
import { CREThemeOptions } from "core/theme/CRETheme";
import { FixAutoThemeOptions } from "core/theme/FixAutoTheme";
import { FixNationRestorationTheme } from "core/theme/FixNationRestorationTheme";
import { NovusCrystalGlassThemeOptions } from "core/theme/NovusCrystalGlassTheme";
import { NovusGlassThemeOptions } from "core/theme/NovusGlassTheme";
import { ProColorThemeOptions } from "core/theme/ProColorTheme";
import { SpeedyAutoThemeOptions } from "core/theme/SpeedyAutoTheme";
import { SpeedyGlassThemeOptions } from "core/theme/SpeedyGlassTheme";

export const BrandMap = new Map<BrandCode, Brand>();

BrandMap.set("novusglass", {
  brandClassification: "Glass",
  brandCode: "novusglass",
  brandTwoLetterCode: "NG",
  themeOptions: NovusGlassThemeOptions,
});

BrandMap.set("crystalglass", {
  brandClassification: "Glass",
  brandCode: "crystalglass",
  brandTwoLetterCode: "NC",
  themeOptions: NovusCrystalGlassThemeOptions,
});

BrandMap.set("speedyauto", {
  brandClassification: "Mechanical",
  brandCode: "speedyauto",
  brandTwoLetterCode: "SA",
  themeOptions: SpeedyAutoThemeOptions,
});

BrandMap.set("speedyglass", {
  brandClassification: "Glass",
  brandCode: "speedyglass",
  brandTwoLetterCode: "SG",
  themeOptions: SpeedyGlassThemeOptions,
});

BrandMap.set("fixaut", {
  brandClassification: "Collision",
  brandCode: "fixaut",
  brandTwoLetterCode: "FA",
  themeOptions: FixAutoThemeOptions,
});

BrandMap.set("proc", {
  brandClassification: "Collision",
  brandCode: "proc",
  brandTwoLetterCode: "PC",
  themeOptions: ProColorThemeOptions,
});

BrandMap.set("cre", {
  brandClassification: "Collision",
  brandCode: "cre",
  brandTwoLetterCode: "CR",
  themeOptions: CREThemeOptions,
});

BrandMap.set("nationrestoration", {
  brandCode: "nationrestoration",
  brandTwoLetterCode: "NR",
  themeOptions: FixNationRestorationTheme,
  brandClassification: "Home",
});

export default BrandMap;
